import { FC } from "react";
import { View, StyleSheet } from "@react-pdf/renderer";

import { Field } from "../../common";
import { formatDate } from "../../../../utils/date";

type Props = {
  exchangeDate: string;
  paymentDate?: string;
};

const styles = StyleSheet.create({
  wrapper: {
    display: "flex",
    flexDirection: "row",
    columnGap: 32,
  },
});

export const DatesSection: FC<Props> = ({ paymentDate, exchangeDate }) => {
  return (
    <View style={styles.wrapper}>
      <Field
        label="Exchange date"
        value={exchangeDate ? formatDate(exchangeDate) : "-"}
      />

      <Field
        label="Payment date"
        value={exchangeDate ? formatDate(paymentDate) : "-"}
      />
    </View>
  );
};
